import { To, useNavigate } from 'react-router';

import { ErrorCard } from '../../../molecules';

interface ErrorBoundaryMessageProps {
  titleText: string;
  messageText: string;
  btnText: string;
  redirectTo?: To;
  showDetails?: boolean;
  componentStack?: string;
  error?: unknown;
  resetError?: () => void;
}

/**
 * Error boundary fallback component.
 * Uses native HTML button to avoid triggering Mantine's useMediaQuery hook
 * during error recovery, which can cause infinite render loops.
 */
export const ErrorBoundaryMessage = ({
  titleText = '',
  messageText = '',
  btnText = '',
  redirectTo = '',
  showDetails = false,
  componentStack = '',
  error,
  resetError,
}: ErrorBoundaryMessageProps) => {
  const navigate = useNavigate();

  return (
    <ErrorCard
      title={titleText}
      guideline={messageText}
      content={
        <>
          <button
            type="button"
            onClick={() => {
              resetError?.();
              if (redirectTo) {
                navigate(redirectTo);
              }
            }}
            className="text-gray-7 border-gray-2 hover:bg-gray-0 text-2xs h-8 cursor-pointer rounded-sm border px-6 font-semibold"
          >
            {btnText}
          </button>
          {showDetails && (
            <div className="mt-4 border-t-2 text-center">
              <div className="py-3 text-lg font-semibold">{error?.toString()}</div>
              <div>{componentStack}</div>
            </div>
          )}
        </>
      }
    />
  );
};
